module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.icon && _vm.icon.startsWith('#')) ? _c('svg', {
    staticClass: "icon svg-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": _vm.icon
    }
  })]) : (_vm.icon && _vm.icon.startsWith('/static')) ? _c('img', {
    staticStyle: {
      "width": "20px",
      "transform": "translateY(4px)"
    },
    attrs: {
      "src": _vm.icon
    }
  }) : _c('i', {
    class: _vm.icon
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?{"id":"data-v-7137afc2","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common_page/sys_code_icon_show.vue
// module id = 6BR1
// module chunks = 81